<template>
  <div>
    <ApiError :errors="errors" />
    <div :class="isMobilePortrait ? 'd-flex flex-column' : ''">
      <v-textarea
        v-if="isMobilePortrait"
        @input="onInput"
        :value="value && value.id ? value.displayName : ''"
        v-bind="$attrs"
        :disabled="disabled"
        v-on="$listeners"
        :clearable="clearable"
        readonly
        auto-grow
        rows="1"
      />
      <v-text-field
        v-else
        @input="onInput"
        :value="value && value.id ? value.displayName : ''"
        v-bind="$attrs"
        :disabled="disabled"
        v-on="$listeners"
        :clearable="clearable"
        readonly
      >
        <template v-slot:append-outer v-if="!isMobilePortrait">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: on }">
              <v-btn v-on="on" @click="updateBankAccount" :loading="plaidDialog">
                <span v-if="value && value.id"><v-icon>mdi-circle-edit-outline</v-icon> Update</span>
                <span v-else><v-icon>mdi-plus</v-icon> Add</span>
              </v-btn>
            </template>
            <span v-if="value && value.id">{{ $i18n.translate("Update") }}</span>
            <span v-else>{{ $i18n.translate("Add") }}</span>
          </v-tooltip>
        </template>
      </v-text-field>
      <v-tooltip bottom v-if="isMobilePortrait">
        <template v-slot:activator="{ on: on }">
          <v-btn v-on="on" @click="updateBankAccount" :loading="plaidDialog" block class="mb-2 pr-8">
            <span v-if="value && value.id"><v-icon left>mdi-circle-edit-outline</v-icon> Update</span>
            <span v-else><v-icon left>mdi-plus</v-icon> Add</span>
          </v-btn>
        </template>
        <span v-if="value && value.id">{{ $i18n.translate("Update") }}</span>
        <span v-else>{{ $i18n.translate("Add") }}</span>
      </v-tooltip>
    </div>
    <PlaidDialog
      v-model="plaidDialog"
      :existingPlaidAccount="value && value.id && value.plaidAccount ? value.plaidAccount : null"
      @complete="completePlaidAccountLink"
      @error-on-bank-account="errorOnBankAccount"
      :participant="participant"
      :forExternalAccount="forExternalAccount"
      :isPublic="isPublic"
    />
  </div>
</template>

<script>
import ApiService from "@/gapp-components/services/api.service";
import PlaidDialog from "../common/transaction/PlaidDialog";
import ApiError from "@/gapp-components/components/display/ApiError.vue";

export default {
  name: "BankAccountField",
  components: { PlaidDialog, ApiError },
  props: {
    value: Object,
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    participant: Object,
    existingPlaidAccount: Object,
    forExternalAccount: { type: Boolean, default: false },
    isPublic: { type: Boolean, default: false }
  },
  data() {
    return {
      plaidDialog: null,
      items: [],
      selectedAwardVehicle: undefined,
      errors: {}
    };
  },
  methods: {
    updateBankAccount() {
      this.plaidDialog = "UPDATE";
    },
    errorOnBankAccount(error) {
      this.plaidDialog = null;
      if (error) {
        this.errors = ApiService.getErrorsFromResponse(error);
        setTimeout(() => (this.errors = {}), 3000);
      }
    },
    onInput(obj) {
      this.$emit("input", obj);
    },
    completePlaidAccountLink(plaidAccount) {
      this.plaidDialog = null;
      this.$emit("bankAccount", plaidAccount.bankAccount);
    }
  }
};
</script>
